import opportunitiesService from '../../../services/opportunities-service';

export const LOAD_OPPORTUNITIES = 'LOAD_OPPORTUNITIES';


export function loadOpportunities(fetchCount, businessName, filters) {
  return (dispatch) => {
    opportunitiesService.getCrossSellOpportunities(fetchCount, businessName, filters)
      .then((opportunities) => {
        dispatch({
          type: LOAD_OPPORTUNITIES,
          opportunities
        })
      });
  };
}

export function loadOpportunitiesReducer(state = [], action) {
  if (action.type === LOAD_OPPORTUNITIES) {
    return action.opportunities;
  } else {
    return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Opportunities/modules/Opportunities.js